// FormThree.js
import React, { useCallback, useEffect, useState } from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { useSelector } from "react-redux";
import {
	PopoverBody,
	PopoverHeader,
	Spinner,
	UncontrolledPopover
} from "reactstrap";
import renderField from "./renderOptionField";
import TextArea from "components/ReduxForm/TextArea";

// const events = [
// 	{
// 		_id: "667dad14996e70a66d98c52d",
// 		title:
// 			"A5M - Conceito da deficiência biopsicossocial: direitos das pessoas com deficiência com foco na autonomia e independência",
// 		description:
// 			"08:00- 09:00 - Conceito da deficiência biopsicossocial: direitos das pessoas com deficiência com foco na autonomia e independência - \tDra. Indyara de Araujo Moraes – Brasília/DF <br>\n09:00 -12:00 - SUB PALESTRAS <br>\nConvenção Internacional dos Direitos das Pessoas com Deficiência: Implementação no Brasil sob a ótica da Assistência Social - Dra. Indyara de Araujo Moraes – Brasília/DF <br>\nA crescente longevidade das pessoas com deficiência: estamos preparados? Uma conversa sobre sucessão familiar e temas relacionados\tEsp. Ricardo Pimenta – Itaúna/MG <br>\nResidências inclusivas: políticas públicas e levantamentos dos serviços existentes no Brasil - Dr. Éverton Luís Pereira - Brasília/DF"
// 	},
// 	{
// 		_id: "667f02c27a475f999577f9fe",
// 		title:
// 			"B5M - Tecnologia assistiva, outros auxílios tecnológicos e processos para o viver independente: autonomia, independência e manutenção das capacidades funcionais das Pessoas com Deficiência",
// 		description:
// 			"08:00 - 09:00 - Tecnologia assistiva, outros auxílios tecnológicos e processos para o viver independente: autonomia, independência e manutenção das capacidades funcionais das Pessoas com Deficiência - Drª Débora Liberato – Natal/RN <br>\nMESA REDONDA–TECNOLOGIA ASSISTIVA <br>\n09:00 - 10:00 - Desenvolvimento de conhecimento e às tecnologias para apoiar a vida, o bem estar e o cuidado à pessoa idosa com deficiência: gerontecnologia. - Dr. Johannes Doll – Porto Alegre/RS <br>\n10:00 - 11:00 - Ateliê de Jogos Digitais - Drª Adriana Gomes Alves – Itajaí/SC <br>\n11:00 - 12:00 - RELATOS DE EXPERIÊNCIA <br>"
// 	},
// 	{
// 		_id: "667f017f7a475f999577f99c",
// 		title: "A7V - FORMALIZAÇÃO DOS TERMOS DE CONVÊNIOS E PRESTAÇÃO DE CONTAS.",
// 		description:
// 			"13:30 - 17:00 - FORMALIZAÇÃO DOS TERMOS DE CONVÊNIOS E PRESTAÇÃO DE CONTAS. -  Esp. Patrick Basso - FCEE - São José/SC <br>\nEsp. Zadir Teresinha Machado Ferreira - Florianópolis/SC <br>"
// 	}
// ];

const FormEight = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormEightSubmit,
		change
		// events
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("certificate_emission");

	const loading = selector(state, "loading");

	const handleNextClick = e => {
		e.preventDefault();
		handleSubmit(onFormEightSubmit);
	};

	return (
		<div>
			<form className="form" onSubmit={handleNextClick}>
				<div className="form__form-group">
					<div className="flex-center">
						<h3 className="account__sub-title text-center">
							Sugestões, reclamações ou elogios
						</h3>
					</div>
					<br />
					<span className="form__form-group-label">
						Preencha o campo abaixo com suas sugestões, reclamações ou elogios
					</span>
					<div className="form__form-group-field">
						<Field
							name="suggestions"
							component={TextArea}
							type="text"
							placeholder="Ex.: Gostei muito do evento, ano que vem estarei presente novamente!"
						/>
					</div>
					<br />
				</div>

				<div className="account__btn__group">
					<button
						type="button"
						className="btn btn-primary account__btn account__btn--small"
						onClick={previousPage}
					>
						Voltar
					</button>
					<button
						type="submit"
						className="btn btn-primary account__btn account__btn--small"
						disabled={pristine || submitting || loading}
					>
						{loading ? (
							<Spinner type="grow" size="sm" color="dark" />
						) : (
							"Emitir"
						)}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: "certificate_emission",
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	validate: v => validate(v, 7)
})(FormEight);
